import { Link } from "@radix-ui/themes";
import { useQuery, useQueryClient } from "react-query";
import { useTranslation } from "react-i18next";

export const AdvancedMode = ({
  children,
  suffix,
  startOpen,
  key,
}: {
  children: React.ReactNode;
  suffix?: string;
  startOpen?: boolean;
  key?: string;
}) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const more = useQuery(["form-advanced-mode", key], () => startOpen || false, {
    enabled: false,
    initialData: startOpen || false,
  }).data;
  const setMore = (value: boolean) => {
    queryClient.setQueryData(["form-advanced-mode", key], value);
  };

  return (
    <>
      {!more && (
        <Link
          size={"2"}
          className="block"
          href="#"
          onClick={() => setMore(!more)}
        >
          {t("components.advanced_mode.show")} {suffix ? " - " + suffix : ""}
        </Link>
      )}

      {more && children}

      {more && (
        <Link
          size={"2"}
          className="block"
          href="#"
          onClick={() => setMore(!more)}
        >
          {t("components.advanced_mode.hide")}
        </Link>
      )}
    </>
  );
};
